// src/components/Sidebar.js
import React from "react";

export default function Sidebar({
  canvas,
  setCanvasSize,
  setBackground,
  setGradient,
  setTransparentBackground,
  setOpacity,
  resetBackground,
  uploading,
  fileBgRef,
  fileLayerImgRef,
  fileLayerVideoRef,
  handleUpload,
  addLayer
}) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 15 }} className="sidebar-grid">
      {/* العمود الأول */}
      <div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
            العرض:
          </label>
          <input 
            type="number" 
            value={canvas.width}
            onChange={e => setCanvasSize(Number(e.target.value), canvas.height)}
            style={{ 
              width: "100%", 
              padding: "8px", 
              border: "1px solid var(--border-color)", 
              borderRadius: 6,
              fontSize: 14,
              background: "var(--bg-secondary)",
              color: "var(--text-primary)"
            }} 
          />
        </div>
        
        <div style={{ marginBottom: 10 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
            الارتفاع:
          </label>
          <input 
            type="number" 
            value={canvas.height}
            onChange={e => setCanvasSize(canvas.width, Number(e.target.value))}
            style={{ 
              width: "100%", 
              padding: "8px", 
              border: "1px solid var(--border-color)", 
              borderRadius: 6,
              fontSize: 14,
              background: "var(--bg-secondary)",
              color: "var(--text-primary)"
            }} 
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
            شفافية الخلفية:
          </label>
          <input 
            type="range" 
            min={0} 
            max={1} 
            step={0.05} 
            value={canvas.opacity || 1}
            onChange={e => setOpacity(Number(e.target.value))}
            style={{ width: "100%" }}
          />
          <div style={{ textAlign: "center", fontSize: 12, color: "var(--text-secondary)", marginTop: 5 }}>
            {Math.round((canvas.opacity || 1) * 100)}%
          </div>
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
            نوع الخلفية:
          </label>
          <select 
            value={canvas.backgroundType}
            onChange={e => setBackground(e.target.value, canvas.backgroundValue)}
            style={{ 
              width: "100%", 
              padding: "8px", 
              border: "1px solid var(--border-color)", 
              borderRadius: 6,
              fontSize: 14,
              background: "var(--bg-secondary)",
              color: "var(--text-primary)"
            }}
          >
            <option value="none">بلا خلفية</option>
            <option value="color">لون</option>
            <option value="gradient">تدرج لوني</option>
            <option value="image">صورة</option>
            <option value="video">فيديو</option>
          </select>
        </div>
      </div>

      {/* العمود الثاني */}
      <div>
        {canvas.backgroundType === "color" && (
          <div style={{ marginBottom: 15 }}>
            <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
              لون الخلفية:
            </label>
            <input
              type="color"
              value={canvas.backgroundValue}
              onChange={e => setBackground("color", e.target.value)}
              style={{ 
                width: "100%", 
                height: "40px", 
                border: "1px solid var(--border-color)", 
                borderRadius: 6,
                cursor: "pointer"
              }}
            />
          </div>
        )}

        {canvas.backgroundType === "gradient" && (
          <div style={{ marginBottom: 15 }}>
            <div style={{ marginBottom: 10 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                لون البداية:
              </label>
              <input 
                type="color" 
                value={canvas.gradient.from}
                onChange={e => setGradient("from", e.target.value)}
                style={{ 
                  width: "100%", 
                  height: "35px", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: 6,
                  cursor: "pointer"
                }} 
              />
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                لون النهاية:
              </label>
              <input 
                type="color" 
                value={canvas.gradient.to}
                onChange={e => setGradient("to", e.target.value)}
                style={{ 
                  width: "100%", 
                  height: "35px", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: 6,
                  cursor: "pointer"
                }} 
              />
            </div>
            <div>
              <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
                زاوية التدرج: {canvas.gradient.angle}°
              </label>
              <input 
                type="range" 
                min={0} 
                max={360} 
                value={canvas.gradient.angle}
                onChange={e => setGradient("angle", Number(e.target.value))}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        )}

        {(canvas.backgroundType === "image" || canvas.backgroundType === "video") && (
          <div style={{ marginBottom: 15 }}>
            <label style={{ display: "block", marginBottom: 5, fontWeight: "bold", color: "var(--text-primary)" }}>
              رابط {canvas.backgroundType === "image" ? "الصورة" : "الفيديو"}:
            </label>
            <input
              type="text"
              value={canvas.backgroundValue}
              onChange={e => setBackground(canvas.backgroundType, e.target.value)}
              placeholder={`رابط ${canvas.backgroundType === "image" ? "الصورة" : "الفيديو"}`}
              style={{ 
                width: "100%", 
                padding: "8px", 
                border: "1px solid var(--border-color)", 
                borderRadius: 6,
                fontSize: 14,
                marginBottom: 8,
                background: "var(--bg-secondary)",
                color: "var(--text-primary)"
              }}
            />
            <input
              type="file"
              accept="image/*,video/*"
              ref={fileBgRef}
              disabled={uploading}
              onChange={e => handleUpload(e, "bg")}
              style={{ 
                width: "100%", 
                padding: "6px", 
                border: "1px solid var(--border-color)", 
                borderRadius: 6,
                fontSize: 12,
                background: "var(--bg-secondary)",
                color: "var(--text-primary)"
              }}
            />
            <div style={{ fontSize: 11, color: "var(--text-secondary)", marginTop: 5 }}>
              ارفع صورة أو فيديو كخلفية (سيتم تحديد النوع تلقائياً)
            </div>
          </div>
        )}

        {canvas.backgroundType === "none" && (
          <div style={{ 
            marginBottom: 15, 
            padding: "15px", 
            background: "var(--success-color)", 
            borderRadius: "8px",
            textAlign: "center"
          }}>
            <div style={{ 
              fontSize: "14px", 
              color: "white", 
              fontWeight: "bold",
              marginBottom: "5px"
            }}>
              ✅ خلفية شفافة
            </div>
            <div style={{ 
              fontSize: "12px", 
              color: "rgba(255,255,255,0.9)",
              marginBottom: "10px"
            }}>
              الخلفية شفافة تماماً - مثالية للبث المباشر
            </div>
            <button
              onClick={() => {
                setBackground("none", "");
                setTransparentBackground(true);
              }}
              style={{
                background: "rgba(255,255,255,0.2)",
                border: "1px solid rgba(255,255,255,0.3)",
                color: "white",
                padding: "8px 16px",
                borderRadius: "6px",
                fontSize: "12px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
              onMouseEnter={(e) => e.target.style.background = "rgba(255,255,255,0.3)"}
              onMouseLeave={(e) => e.target.style.background = "rgba(255,255,255,0.2)"}
            >
              تأكيد الشفافية
            </button>
          </div>
        )}

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
            <input 
              type="checkbox" 
              checked={canvas.transparentBackground !== false}
              onChange={e => setTransparentBackground(e.target.checked)}
              style={{ transform: "scale(1.2)" }}
            />
            <span style={{ 
              color: canvas.transparentBackground !== false ? "var(--success-color)" : "var(--text-secondary)",
              fontWeight: canvas.transparentBackground !== false ? "bold" : "normal"
            }}>
              خلفية شفافة للبث المباشر
            </span>
          </label>
          <div style={{ 
            fontSize: 11, 
            color: "var(--text-secondary)", 
            marginTop: 5, 
            lineHeight: 1.4
          }}>
            {canvas.transparentBackground !== false 
              ? "✅ الشفافية مفعلة - الخلفية ستكون شفافة تماماً (مناسبة لـ OBS)" 
              : "⚠️ الشفافية معطلة - ستظهر الخلفية المحددة (مناسبة للعرض المباشر)"
            }
          </div>
          <div style={{ 
            fontSize: 10, 
            color: "var(--text-secondary)", 
            marginTop: 3,
            fontStyle: "italic"
          }}>
            الحالة الحالية: {canvas.transparentBackground !== false ? "شفافة" : "ظاهرة"} | النوع: {canvas.backgroundType}
          </div>
        </div>

        {/* زر إعادة تعيين الخلفية */}
        <div style={{ 
          marginTop: 20, 
          padding: "15px", 
          background: "var(--warning-color)", 
          borderRadius: "8px",
          textAlign: "center"
        }}>
          <div style={{ 
            fontSize: "12px", 
            color: "white", 
            fontWeight: "bold",
            marginBottom: "8px"
          }}>
            🔄 إعادة تعيين الخلفية
          </div>
          <button
            onClick={resetBackground}
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "1px solid rgba(255,255,255,0.3)",
              color: "white",
              padding: "8px 16px",
              borderRadius: "6px",
              fontSize: "12px",
              cursor: "pointer",
              fontWeight: "bold"
            }}
            onMouseEnter={(e) => e.target.style.background = "rgba(255,255,255,0.3)"}
            onMouseLeave={(e) => e.target.style.background = "rgba(255,255,255,0.2)"}
          >
            إعادة تعيين إلى شفافة
          </button>
        </div>
      </div>
    </div>
  );
}
